// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__rwIQm","inputWrap":"style_inputWrap__nCl6Q","result":"style_result__hplCE"};